// extracted by mini-css-extract-plugin
export default {"main":"ForgotPassword_main__DCohD","form":"ForgotPassword_form__-S6Db"};